/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  progress: 0,
  datafile: null,
  error: null,
};

const downloadSlice = createSlice({
  name: "download",
  initialState,
  reducers: {
    iniciarCarga: (state) => {
      state.loading = true;
      state.progress = 0;
      state.error = null;
    },
    actualizarProgreso: (state, action) => {
      state.progress = action.payload;
    },
    cargaExitosa: (state, action) => {
      state.loading = false;
      state.progress = 100;
      state.datafile = action.payload;
    },
    cargaFallida: (state, action) => {
      state.loading = false;
      state.progress = 100;
      state.error = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  iniciarCarga,
  actualizarProgreso,
  cargaExitosa,
  cargaFallida,
  reset,
} = downloadSlice.actions;

export default downloadSlice.reducer;

